<template>
  <div class="footer-main">
    <footer class="footer">
      <div class="footer-column"> 
        <p  @click="navigateTo('/hakkimizda')" class="menu-item">{{ $t('layout.footer.menu.about') }}</p>
        <p  @click="navigateTo('/urunler')" class="menu-item">{{ $t('layout.footer.menu.products') }}</p>
        <p  @click="navigateTo('/portal')" class="menu-item">{{ $t('layout.footer.menu.portal') }}</p>
        <p  @click="navigateTo('/ucretsizegitim')" class="menu-item">{{ $t('layout.footer.menu.online_education') }}</p>
        <p  @click="navigateTo('/masterclassegitim')" class="menu-item">{{ $t('layout.footer.menu.master_class') }}</p>  
      </div>
      <div class="footer-column"> 
        <p  @click="navigateTo('/sozlesmeler')" class="menu-item">{{ $t('layout.footer.menu.agreements') }}</p> 
        <p  @click="navigateTo('/kullanim-kosullari')" class="menu-item">{{ $t('layout.footer.menu.terms') }}</p>
        <p  @click="navigateTo('/cerez-politikasi')" class="menu-item">{{ $t('layout.footer.menu.cookies') }}</p>
        <p  @click="navigateTo('/veri-gizliligi')" class="menu-item">{{ $t('layout.footer.menu.privacy') }}</p>
        <p  @click="navigateTo('/sertifikalar')" class="menu-item">{{ $t('layout.footer.menu.standards') }}</p>
        
      </div>
      <div class="footer-column">  
        <p  @click="navigateTo('/iletisim')" class="menu-item">{{ $t('layout.footer.menu.contact') }}</p>
        <p  @click="navigateTo('/kullanim-kilavuzu')" class="menu-item">{{ $t('layout.footer.menu.user_guide') }}</p> 
        <p  @click="navigateTo('/sss')" class="menu-item">{{ $t('layout.footer.menu.faq') }}</p>
        <p  @click="navigateTo('/etkinlikler')" class="menu-item">{{ $t('layout.footer.menu.announcements') }}</p>  
        <p  @click="navigateTo('/marka-materyal')" class="menu-item">{{ $t('layout.footer.menu.brand_kit') }}</p> 
      </div>

      <div class="footer-column">  
        <img src="@/assets/icon/footer-logo.svg" class="logo" :alt="$t('layout.footer.icons.logo_alt')">  

        <div class="store-contianer">
          <img src="@/assets/icon/footer/ios.svg" class="store" :alt="$t('layout.footer.icons.ios_alt')" >
          <img src="@/assets/icon/footer/android.svg" class="store" :alt="$t('layout.footer.icons.android_alt')" >
          <img src="@/assets/icon/footer/hmos.svg" class="store" :alt="$t('layout.footer.icons.hmos_alt')" > 
        </div>

        <div class="store-pwacontianer">
          <p style="color: #776647; font-size: 0.95em;">{{ $t('layout.footer.all_platforms') }}</p>
          <img src="@/assets/icon/footer/pwa.svg" class="storepwa" :alt="$t('layout.footer.icons.pwa_alt')" @click="triggerPWAInstall"> 
        </div>

        <div style="margin-top: 5px;" class="store-pwacontianer"> 
          <img src="@/assets/icon/footer/pwa2.svg" class="storepwaindir" :alt="$t('layout.footer.icons.pwa_alt')" @click="triggerPWAInstall"> 
        </div>

      </div>
        
    </footer>

    <div class="footer-last-child"> 
          <div class="security">
            <img src="@/assets/icon/footer/ssl.svg" class="app-icon" :alt="$t('layout.footer.icons.ssl_alt')"> 
            <img src="@/assets/icon/footer/kvkk.svg" class="app-icon" :alt="$t('layout.footer.icons.kvkk_alt')"> 
            <img src="@/assets/icon/footer/aes.svg" class="app-icon" :alt="$t('layout.footer.icons.aes_alt')"> 
          </div> 
          <div class="powered">
            <img 
              src="/assets/noahai.svg" 
              class="powered-icon" 
              :alt="$t('layout.footer.icons.noah_ai_alt')"
              @click="openNoahAI"
            /> 
          </div>
    </div> 

    <div class="feed">
      <FeedCard />
    </div>

    <div class="sticky-bottom"><p>{{ $t('layout.footer.copyright', { year: currentYear }) }}</p></div>
  </div>
</template>

<script>
import FeedCard from './feedback/FeedCard.vue';

export default {
  components: { 
    FeedCard,
  },
  name: 'MainFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },

  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    openLink(url) {
      window.open(url, '_blank');
    },
    openNoahAI() {
      window.open("https://ai.noahpmu.com/", "_blank");
    },
    triggerPWAInstall() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      const isSafari = /^((?!chrome|android).)*safari/.test(userAgent);
     
      if (isIOS) {
        if (isSafari) {
          alert(this.$t('layout.footer.pwa.ios_safari'));
        } else {
          alert(this.$t('layout.footer.pwa.ios_non_safari'));
        }
        return;
      }
     
      if (window.deferredPrompt) {
        const promptEvent = window.deferredPrompt;
        promptEvent.prompt();
        promptEvent.userChoice.then((result) => {
          if (result.outcome === 'accepted') {
            console.log('PWA yüklemesi kabul edildi.');
          } else {
            console.log('PWA yüklemesi reddedildi.');
          }
          window.deferredPrompt = null;
        });
      } else {
        alert(this.$t('layout.footer.pwa.not_supported'));
      }
      console.log('deferredPrompt', window.deferredPrompt); 
    } 
    
  }
}
</script>

<style scoped>
.footer-main {
  background-color: #000000;
  margin-top: 5rem;
}

.footer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  padding: 2rem 1rem 1rem 1rem; 
  font-size: 0.7rem; 
  user-select: none;
  z-index: 1005;
}

.logo {
  max-width: 180px;
  margin-bottom: 0.5rem;
}

.icon-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.icon { 
  max-height: 30px;
  cursor: pointer;
}

.sticky-bottom {
  position: fixed;
  bottom: 0;
  width: 100%; 
  background-color: #000000;
  padding: 0.5rem 0; 
  padding-right: 32px; 
  text-align: right;
  z-index: 1100;
}

.sticky-bottom p {  
  padding: 0;
  margin: 0;
  padding-right: 32px; 
  font-size: 0.6rem; 
} 

.menu-item {   
  font-size: 0.7rem;
  color: #cecece;
}

.menu-item:hover { 
  color: #ffffff;
  cursor: pointer;
}
.footer-column:last-child {
  opacity: 0.8;
}

.footer-column p {
  margin: 0.4em 0;
}
.store-contianer {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.store {
  max-width: 2.5rem;
  width: 100%;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(2, 48, 50, 0); 
  opacity: 0.8;
  transition: transform 0.3s ease, box-shadow 0.5s ease; 
}
.store:hover { 
  transform: scale(1.04); 
  box-shadow: 0 8px 18px rgba(133, 133, 133, 0.5); 
  opacity: 1;
} 
.store-pwacontianer {
  display: flex;
  flex-wrap: wrap;
  align-items: center; 
  gap: 0.9rem;
  margin-top: 10px;
} 
.storepwa {
  max-width: 2.5rem;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(2, 48, 50, 0); 
  opacity: 0.8;
  transition: transform 0.3s ease, box-shadow 0.5s ease; 
}
.storepwaindir {
  max-width: 9.5rem;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(2, 48, 50, 0); 
  opacity: 0.8;
  transition: transform 0.3s ease, box-shadow 0.5s ease; 
}
.storepwa:hover {   
  box-shadow: 0 8px 18px rgba(133, 133, 133, 0.5); 
  opacity: 1;
} 
.storepwaindir:hover {   
  box-shadow: 0 8px 18px rgba(133, 133, 133, 0.5); 
  opacity: 1;
} 
.app-icon {
  max-height: 4rem; padding-left: 1rem; opacity: 0.3;
} 

.footer-last-child { 
  display: flex; 
  align-items: center; 
  justify-content: space-between;
  width: 100%; 
}
.security { 
  display: flex; 
  align-items: center;  
  width: 100%; 
  opacity: 0.8;
}

.powered {
  width: 100%; 
  display: flex;
  justify-content: center;
}
.powered-icon {
  width: 100%;
  max-height: 5rem; 
  max-width: 12rem;
  margin-left: 12rem;
  cursor: pointer;
}

@media (max-width: 768px) {
  .footer {
    grid-template-columns: repeat(2, 1fr);
  }

  .sticky-bottom p {  
    padding: 0;
    margin: 0;
    padding-right: 32px; 
    font-size: 0.5rem;
  } 
  .icon-row {
    justify-content: space-between; 
  }
  .logo {
    max-width: 150px;
    opacity: 0.8;
    margin-bottom: 0.5rem;
  }
  .app-icon {
    max-height: 3rem; 
    padding-left: 1rem; 
    opacity: 0.3;
  } 
  .powered {
    flex-wrap: wrap;
    min-width: 5rem;
  }
  .powered-icon {
     width: 100%;
     max-height: 5rem; 
     max-width: 12rem; 
     margin-left:0rem;
   }
}  

</style> 